import { collection, deleteDoc, doc, documentId, endAt, getDocs, limit, onSnapshot, orderBy, query, startAfter, startAt, updateDoc, where } from 'firebase/firestore'
import React, { useEffect, useRef, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../firebase';
import { FiEdit } from 'react-icons/fi';
import { MdDelete } from 'react-icons/md';
import { AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import TakeNotes from "../img/take-notes.jpg"
import Colors from './Colors';
import { AiFillTag } from 'react-icons/ai';
import { qActionPlan, qAnalysis, qConclusion, qDesc, qEvaluation } from './questions';

function List ({setCurrentId, setUserTags, currentId, userTags}) { 
  
  const [user] = useAuthState(auth)
  const scroll = useRef()
  const [entries, setEntries] = useState([])
  const [showEntry, setShowEntry] = useState("")
  const [sortTag, setSortTag] = useState("")
  const [sort, setSort] = useState("")
  const [recordQuery, setRecordQuery] = useState()
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [searchWord, setSearchWord] = useState("")
  const [documents, setDocuments] = useState([]); // Array to store loaded documents
  const [lastDocument, setLastDocument] = useState(0); // Track the last document
  const [loading, setLoading] = useState(false); // To prevent multiple simultaneous requests
  const [tagsToDelete, setTagsToDelete] = useState([])
  const [currentSort, setCurrentSort] = useState("")
  const [selectingTags, setSelectingTags] = useState(false)
  const today = new Date()
  const [selectedMonth, setSelectedMonth] = useState("")
  const [promtLookBack, setPromptLookBack] = useState(false)

  /*const qDesc = `What happened during the advising session? Include as much detail as you think is relevant.\n
    (For example: Who was there? When did it happen? How long did it last? What were you and the advisee doing and saying?)`


    const qEmotions = `Refer to the mood meter and choose the one(s) that represents your emotion best.`
    const qEvaluation = `What do you think went well, and how did it impact your emotions? What do you think did not go well, and how did it impact your emotions?`
    const qAnalysis = `Why do you think these emotions came up for you during the session?`
    const qConclusion = `What can you learn about yourself through this experience, if anything?`
    const qActionPlan = `How could you handle a similar session differently in the future?`
 
    const qTitle = `Set a short and explanatory title to help looking back to this entry.`
    const qTags = `Adding tags (topics) to you records can help sort and find records with similar topics.`
    const qDesc = `What happened during the advising session? Include as much detail as you think is relevant.\n
    (For example: Who was there? When did it happen? How long did it last? What were you and the advisee doing and saying?)`

    const qEmotions = `Refer to the mood meter and choose the one(s) that represents your emotion best.`
    const qEvaluation = `What do you think went well, and how did it impact your emotions? \nWhat do you think did not go well, and how did it impact your emotions?`
    const qAnalysis = `Why do you think these emotions came up for you during the session?`
    const qConclusion = `What can you learn about yourself through this experience, if anything?`
    const qActionPlan = `How could you handle a similar session differently in the future?`
*/

  
  const deleteRecord = async (id) => {

    const usersRef = collection(db, "users")
    const userEnrties = collection(usersRef, user.uid, "entries")
    const docRef = doc(userEnrties, id)

    await deleteDoc(docRef)

    setShowDeleteDialog(false)

  }

  function DeteleDialog (){
    return (
    <div className='overlay'>
      <div className='dialog'>
        <h3>Delete this record?</h3>
        <div className='h-list even'>
        <button className='btn inactive' onClick={()=>{setShowDeleteDialog(false)}}>Cancel</button>
        <button className='btn negative' onClick={()=>{deleteRecord(currentId)}}>Delete</button>
        </div>
      </div>

    </div>
    )
  }
  
  
  function deleteTag(tagToRemove){
    const usersCollection = collection(db, "users")
    const userDoc = doc(usersCollection, user.uid)

    const updatedTags = userTags.filter((item)=> item !== tagToRemove)
    setUserTags(updatedTags)

  }
  
  function handleShowEntry (id){

  
    if (showEntry==id){
      setShowEntry("")
      setCurrentId("")

    }else{
      setShowEntry(id)
      setCurrentId(id)
    }

  }

  function deleteTags(){
    const usersCollection = collection(db, "users")
    const userDoc = doc(usersCollection, user.uid)

    let updatedTags
   
      updatedTags = userTags.filter((item)=> !tagsToDelete.includes(item))
    

    updateDoc(userDoc, {userTags: updatedTags})
    setTagsToDelete([])

  }


  const updateRecordQuery = async (sort, date, word) => {

    const selectedDate = new Date(date)

    const startDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1)
    const endDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() +1, 0)

    setSort(sort)
    let newQuery = []
    const usersRef = collection(db, "users")
    const userEnrties = collection(usersRef, user.uid, "entries")
    const querySnap = await getDocs(userEnrties)
    const count = querySnap.size;

    if (count % 5 == 0){
      setPromptLookBack(true)
      console.log("can be devided by 5")
    }else { console.log("record count:" + count)}

    switch (sort){
      case "recent":
      newQuery = query(
        userEnrties,
        orderBy("date", "desc"),
        limit(20)
      ) 
      break;

      case "positive":
        newQuery = query(
          userEnrties,
          where("pleasantness", ">", 0)
        )
        break;

      case "negative":
          newQuery = query(
            userEnrties,
            where("pleasantness", "<", 0)
          )
          break;

      case "word":
        newQuery = query(
          userEnrties,
          where("title", "array-contains", searchWord),
          
        )
          break;

      case "month":
        newQuery = query(
          userEnrties,
          orderBy("date", "desc"),
          where("date", ">=", startDate),
          where("date", "<=", endDate)
        )
        break;

      case "tag":
        newQuery = query(
          userEnrties,
          orderBy("date", "desc"),
          where("tags", "array-contains", word),
 
        )
        break;
      
    }
    

    setRecordQuery(newQuery)

  }

  function openEntry(id){


  }

  function handleTagClick (tag){
    if(selectingTags){

      if(tagsToDelete.includes(tag)){

        setTagsToDelete((prevTags)=>{
          const newTags = tagsToDelete.filter((item)=> item != tag)
          return newTags
        })


      }else {

        setTagsToDelete((prevTags)=>{
          const newTags = [...prevTags, tag]
          return newTags
        })
      }
     
    }else{

      if(searchWord==tag){
        setSearchWord("")
      }else{
        setSearchWord(tag)
        updateRecordQuery("tag", today, tag)
      }

      
    }
  }

  useEffect(()=>{

    updateRecordQuery("recent", today)



    console.log(user.uid)

  },[user])


  useEffect(()=>{

      //const usersRef = collection(db, "users")
      //const userEnrties = collection(usersRef, user.uid, "entries")
      //const q = query(userEnrties, orderBy("date", "desc"), limit(50))
      
      if (recordQuery){
        const unsubscribe = onSnapshot(recordQuery, (snapshot) => {

          const newEntries = snapshot.docs.map((doc)=>{
            const data = doc.data()
            const id = doc.id
            return {id, ...data}
          })

          setEntries(newEntries)

            
      })

      return () => unsubscribe()
      }
      
      
   
  },[recordQuery])


return (


  
    <div className='list-container'>
    {
        showDeleteDialog&&
        <DeteleDialog/>
      }

<h1>Reflection Records</h1>   

<div className='new-btn-container' style={{margin: "20px"}}>
        <Link onClick={()=>{setCurrentId("")}} className='link' to={`/edit`}>
          <div className='btn positive elevated'>
          + New record
          </div>
        </Link>
       
        
    </div>

     
    <div className='fixed-top'>
    <div className='h-list spread'>  
      <button className={sort=="recent"?"active btn elevated":"inactive btn elevated"} onClick={()=>{updateRecordQuery("recent")}}>Show recent records</button>
        <button className={sort=="month"?"active btn elevated":"inactive btn elevated"} onClick={()=>{setSort("month"); setSelectedMonth("")}}>Filter by month</button>
        <button className={sort=="tag"?"active btn elevated":"inactive btn elevated"} onClick={()=>{setSort("tag"); setSearchWord(""); setSelectingTags(false); setTagsToDelete([])}}>Filter by tag</button>
        

          
      </div>
      
        {sort=="month"&&
          <div className='h-list'>
            <label style={{marginRight:"5px"}}>Select the month to diplay:</label> 
              <input  value={sort=="month"?selectedMonth:""}  type='month' onChange={(e)=>{setSelectedMonth(e.target.value) ;updateRecordQuery("month", e.target.value)}}/>
          </div> 
         
        }

        {sort=="tag"&&
       
            <div className='userTags-container center'>
           
              {
              userTags.map((tag, index)=>( 
                <button key={index} className={`text-btn ${tagsToDelete.includes(tag)?"red":""} ${searchWord==tag&&"text-btn positive"}`}
                onClick={()=>{handleTagClick(tag)}}>
                  <AiFillTag/>{tag}
                </button>
              ))
              }
              <button 
              className={`${selectingTags?"text-btn negative elevated":"text-btn req"}`}
              onClick={()=>{ 
                if(selectingTags==true){deleteTags(); setSelectingTags(false)}else {setSelectingTags(true)}
              }}>{selectingTags?"Delete selected tags":"Delete tags"}</button>
              
              {
                selectingTags&&
                <button 
                  className='text-btn positive elevated'
                  onClick={()=>{setSelectingTags(false)}}
                  >Cancel</button>
              }
 
           </div>
   
          
                   
        
        }


                  
        
           
      
    </div>
    

    {/*
      <h2 style={{"marginBottom":"0px"}}>{sort=="recent"?
          "Recent 20 Records":
              sort=="month"?
              selectedMonth.toLocaleString('en-US', {year: "numeric", month: "long"}):
              ""}</h2>
      */}
      
      
      

    
  {/*}
    <button onClick={()=>{updateRecordQuery("recent")}}>recent</button>
    <button onClick={()=>{updateRecordQuery("positive")}}>positive</button>
    
    <button onClick={()=>{updateRecordQuery("negative")}}>negative</button>
  */}


      

    


      
      {
        entries.length==0&&
        <div className='v-list '>
          <h5 className='req'>You don't have any records that match the current sort.</h5></div>
      }
    


      {entries.map((doc, id, index)=>(
      
      <div key={id} className={`list-item 
      ${doc.pleasantness>=1?
        //yes p - positive
          doc.energy>=1?
          //yes e-postive
            "yellow":
          //no e-neut or nega
            doc.energy>-1?
            //yes  e-neut
              "light-green":
            //no e-negative
              "green":
        //no p -neut or negative
          doc.pleasantness>-1?
          //yes - p neutral
            doc.energy>=1?
              //yes e-posi
              "orange":
              doc.energy>-1?
              //yes e-neutral
              "neutral":
              //no e-nega
              "blue-green":
          //no - p negative
            doc.energy>=1?
            //yes e-positive
              "red":
            //no e-neut or nega
              doc.energy>-1?
              //yes e-neut
                "purple":
              //no e-nega
                "blue"}`}>

      <button
        className='list-title'
        onClick={()=>{console.log(doc.id); handleShowEntry(doc.id)}}>
      
        {/*doc.pleasantness>=1? //pleassant +
                doc.energy>=1? //pleasant + and energy +
                  <h1>😃</h1>:<h1>😌</h1>:
                doc.energy>=1?
                  <h1>😫</h1>:<h1>😞</h1>
            
      */ }
     
      {/*
        doc.pleasantness>=1?
        //yes p - positive
          doc.energy>=1?
          //yes e-postive
            <h1>😃</h1>:
          //no e-neut or nega
            doc.energy>-1?
            //yes  e-neut
              <h1>🙂</h1>:
            //no e-negative
              <h1>😌</h1>:
        //no p -neut or negative
          doc.pleasantness>-1?
          //yes - p neutral
            doc.energy>=1?
            //yes e posi
            <h1>😯</h1>:
            //no e-neut or nega
            doc.energy>-1?
            <h1>😐</h1>:
            <h1>😑</h1>:
          //no - p negative
            doc.energy>=1?
            //yes e-positive
              <h1>😫</h1>:
            //no e-neut or nega
              doc.energy>-1?
              //yes e-neut
                <h1>😣</h1>:
              //no e-nega
                <h1>😞</h1>
*/
      }

          {
        doc.pleasantness>=1?
        //yes p - positive
          doc.energy>=1?
          //yes e-postive
            <h1>😃</h1>:
          //no e-neut or nega
            doc.energy>-1?
            //yes  e-neut
              <h1>🙂</h1>:
            //no e-negative
              <h1>😌</h1>:
        //no p -neut or negative
          doc.pleasantness>-1?
          //yes - p neutral
            doc.energy>=1?
            //yes e posi
            <h1>😯</h1>:
            //no e-neut or nega
            doc.energy>-1?
            <h1>😐</h1>:
            <h1>😑</h1>:
          //no - p negative
            doc.energy>=1?
            //yes e-positive
              <h1>😫</h1>:
            //no e-neut or nega
              doc.energy>-1?
              //yes e-neut
                <h1>😣</h1>:
              //no e-nega
                <h1>😞</h1>

}


     
        
      
        <h3 className='abstract'>{doc.title}</h3>
      
        <div>{doc.date.toDate().toLocaleString("en-US", {month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", hour12: false})}</div>
        
        
        
        

        
        
      </button>

      {showEntry==doc.id&&
        <div className='details-container'>
          <div className='h-list even'>
          <button className='edit-btn text-btn' onClick={(e)=>{ e.stopPropagation(e);setShowDeleteDialog(true)}}><MdDelete fontSize="20px"/>Delete</button>
          <Link className='edit-btn text-btn' to={`edit`}><FiEdit/>Edit</Link>
          <button className='edit-btn text-btn' onClick={()=>{handleShowEntry(doc.id)}}><AiOutlineClose fontSize="20px"/>Close</button>
          
          </div>
        <div className='details'>
          <div>
            <h3>1. Description of the moment</h3>
            <h4>{qDesc}</h4>
            <p>{doc.desc}</p>
          </div>
          <div>
            <h3>2. Your emotions</h3>
            {user.email=="sinaka10024@gmail.com"&&<>P: {doc.pleasantness}<br/>E: {doc.energy}</>}
            <p>{doc.emotions.map((emo, index)=>(<span key={index}>{emo.name}, </span>))}</p>
          </div>

          <div>
          <h3>3. Evaluation of the session</h3>
          <h4>{qEvaluation}</h4>
          <p>{doc.evaluation}</p>
          
          </div>
          <div>
          <h3>4. Analysis</h3>
          <h4>{qAnalysis}</h4>
          <p>{doc.analyzeEmo}</p>
     
          {
          //<h4>What impact, if any, did your feelings have on the advisee and/or the advising dialogue?</h4>
          //<p>{doc.impact}</p>
          }
          
          </div>

          <div>
            <h3>5. Conclusion</h3>
            <h4>{qConclusion}</h4>
            <p>{doc.learnYourself}</p>
          </div>

          <div className='details-item'>
            <h3>6. Action plan</h3>
            <h4>{qActionPlan}</h4>
            <p>{doc.actionPlan}</p>
          </div>
        </div>
        </div>}
      </div>
      ))}
    </div>



)
}

export default List